<ds-modal
    [accentBarTone]="accentBarTone"
    [detachFooter]="true"
    [ds-modal-trigger-for]="modalTemplate"
    [isModalOpen]="isOpen"
    [isDismissable]="isDismissable"
    [dimensionsConfig]="dimensionsConfig"
    #modalTemplate
    (dismiss)="close()"
    (isModalOpenChange)="onOpenChange($event)">
    <ds-box-header
        variant="regular"
        icon="error"
        [isDismissable]="true"
        (dismissEvent)="close()">
        {{ title }}
    </ds-box-header>
    <ds-box-content surfaceTone="ghost">
        <ng-content *ngIf="useProjectedContent"></ng-content>
        <p
            *ngIf="!useProjectedContent && !innerHtmlMessage"
            class="density-confirmation-dialog__message text-regular">
            {{ message }}
        </p>
        <div
            *ngIf="!useProjectedContent && innerHtmlMessage"
            class="density-confirmation-dialog__message text-regular"
            [innerHTML]="message"></div>
    </ds-box-content>
    <ds-box-footer variant="regular">
        <div class="density-confirmation-dialog__footer">
            <button
                ds-button
                type="button"
                variant="outline"
                (click)="close()">
                {{ cancelLabel }}
            </button>
            <button
                ds-button
                type="button"
                [variant]="confirmButtonVariant"
                (click)="onConfirm()">
                {{ confirmLabel }}
            </button>
        </div>
    </ds-box-footer>
</ds-modal>
